import { Link } from 'react-router-dom';
import { useT } from '@dia/i18n';
import { useOutbox } from '@dia/db';
import { LangToggle, Screen, SyncBadge } from '@dia/ui';
import { useAuth } from '../../auth';
import { sync } from '../../supabase';
import type { ComposerMode } from '../logic/helpThread';
import { BackLink } from './BackLink';
import { HelpThread } from './HelpThread';
import { useAccess } from './useAccess';

/**
 * The page frame the two old addresses share: the title, the sync badge and
 * the language switch, the way back home, and the signed out and closed window
 * states. Inside it is the same HelpThread the help sheet shows.
 */
export function HelpThreadPage({
  title,
  lede,
  mode,
  signInFirst,
  locked,
}: {
  title: string;
  lede: string;
  mode: ComposerMode;
  signInFirst: string;
  locked: string;
}) {
  const { t } = useT();
  const { session } = useAuth();
  const access = useAccess();
  const { pending, dead, online, syncing } = useOutbox(sync);

  return (
    <Screen
      title={title}
      lede={lede}
      actions={
        <>
          <SyncBadge pending={pending} dead={dead} online={online} syncing={syncing} />
          <LangToggle />
        </>
      }
    >
      <BackLink />

      {!session && (
        <p className="mt-2 flex flex-col gap-3 text-inkMuted">
          {signInFirst}
          <Link to="/entrar" className="text-accent underline underline-offset-4 min-h-tap inline-flex items-center">
            {t('guest.arrive.sign_in')}
          </Link>
        </p>
      )}

      {session && access && !access.personalOpen && (
        <p className="mt-2 text-inkMuted" role="status">
          {locked}
        </p>
      )}

      {session && access?.personalOpen && (
        <div className="mt-2">
          <HelpThread initialMode={mode} />
        </div>
      )}
    </Screen>
  );
}
